// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kq-c";
export var backButton = "_kq-4";
export var backIcon = "_kq-5";
export var chevronShortcut = "_kq-6";
export var container = "_kq-1";
export var editor = "_kq-8";
export var editorWrapper = "_kq-7";
export var prefix = "_kq-2";
export var searchIcon = "_kq-3";
export var suffix = "_kq-9";
export var suffixContent = "_kq-a";
export var suffixText = "_kq-b";
export var wrapper = "_kq-0";